import React from 'react';
import Img from 'gatsby-image';
import { getFluidGatsbyImage } from 'gatsby-source-sanity';
import { AppControlContext } from '../../../context/AppControlContext';
import clientConfig from '../../../../client-config';
import './postVideo.css';

const PostVideo = ({ videoData }) => {
  const { modalIsOpen, setModalIsOpen } = React.useContext(AppControlContext);
  return (
    <div className="blog-video-wrapper" key={Math.random().toString(32).substring(7)}>
      <div className="video-thumbnail">
        <button
          className="image-wrapper"
          onClick={() => {
            setModalIsOpen(!modalIsOpen);
          }}
        >
          <Img
            key={Math.random().toString(32).substring(7)}
            fluid={getFluidGatsbyImage(videoData.thumbnail.src.asset._ref, { maxWidth: 675 }, clientConfig.sanity)}
            alt="video-name"
          />
          <div className="play-icon">
            <i className="icon-play" />
          </div>
        </button>
      </div>
      {modalIsOpen ? (
        <div className="modal" id="refLibModal" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setModalIsOpen(!modalIsOpen);
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <div className="modal-body">
                <iframe
                  className=""
                  src={videoData?.youtubeUrl}
                  id="video"
                  allowscriptaccess="always"
                  allow="autoplay"
                  title="ld"
                  width="100%"
                  height="400"
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PostVideo;
